import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import { useAuth } from "../../contexts/AuthContext";

const navItems = [
  { to: "/client", end: true, label: "Dashboard" },
  { to: "/client/documents", label: "Documents" },
  { to: "/client/work-updates", label: "Work Updates" },
];

export default function ClientPortalLayout() {
  const { userData } = useAuth();

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <header className="border-b border-white/10 bg-[#0B1F33] text-white">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-4 px-5 py-4">
          <div className="flex items-center gap-4">
            <img src="/brand/pravah-wordmark.png" alt="Pravah" className="h-8 w-auto object-contain" />
            <div className="hidden border-l border-white/20 pl-4 sm:block">
              <p className="text-xs uppercase tracking-[0.2em] text-white/55">Client Portal</p>
              <p className="mt-0.5 text-sm font-medium text-white/90">{userData?.clientName || userData?.name || "Client"}</p>
            </div>
          </div>
          <button
            type="button"
            onClick={() => signOut(auth)}
            className="rounded-lg border border-white/20 px-4 py-2 text-sm font-semibold transition hover:bg-white/10"
          >
            Sign out
          </button>
        </div>
        <nav className="mx-auto flex max-w-6xl gap-1 overflow-x-auto px-5">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `whitespace-nowrap border-b-2 px-4 py-3 text-sm font-semibold transition ${
                  isActive
                    ? "border-[#C8A96B] text-white"
                    : "border-transparent text-white/65 hover:text-white"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="mx-auto max-w-6xl px-5 py-8">
        <Outlet />
      </main>
    </div>
  );
}
